var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6L11.6667 6",
    stroke: "#596780",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10H15",
    stroke: "#596780",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14L15 14",
    stroke: "#596780",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18L15 18",
    stroke: "#596780",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66669 21.4V2.6C1.66669 2.26863 1.93532 2 2.26669 2H15.1357C15.3137 2 15.4826 2.07909 15.5966 2.21589L18.1943 5.33312C18.2841 5.44095 18.3334 5.57687 18.3334 5.71723V21.4C18.3334 21.7314 18.0647 22 17.7334 22H2.26669C1.93532 22 1.66669 21.7314 1.66669 21.4Z",
    stroke: "#596780",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.4V2.28376C15 2.12704 15.127 2 15.2838 2C15.368 2 15.4478 2.03741 15.5018 2.1021L18.2482 5.3979C18.3032 5.46387 18.3333 5.54703 18.3333 5.63291C18.3333 5.83565 18.169 6 17.9662 6H15.6C15.2686 6 15 5.73137 15 5.4Z",
    fill: "#596780",
    stroke: "#596780",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5 18V14H6.66667V18H5Z",
    fill: "#596780",
    stroke: "#596780",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporting);
export default __webpack_public_path__ + "static/media/reporting.f07aec4f84727196597aad4db8e71e7c.svg";
export { ForwardRef as ReactComponent };